module.exports = __webpack_public_path__ + "static/img/icon_app_010.2973dbb7.png";